import {useEffect, useState} from "react";
import {agent} from "../../../api/agent";
import LoadingContainer from "../../LoadingContainer";
import styled from "styled-components";
import SearchInput from "../../Search/SearchInput";
import RepoPermissions from "./RepoPermissions";

interface Props {
    permissions: string[];
    onChange: (permissions: string[]) => void;
}

const Repo = styled.div`

    cursor: pointer;
    padding: .5rem 1.5rem;
    
    &:hover {
        background-color: var(--content-box-hover);
    }
    
    h2 {
        margin: 0;
        font-size: 1.2rem;
    }
`;

const Back = styled.div`
    cursor: pointer;
    padding: .5rem .5rem;

    &:hover {
        background-color: var(--content-box-hover);
    }
    
    span {
        margin-left: .5rem;
        font-size: 1.2rem;
    }
    
`;

interface _Repo {
    name: string;
    amount: number;
    id: string;
}

export default function RepoList(props: Props) {

    const [repos, setRepos] = useState<_Repo[]>([]);
    const [filteredRepos, setFilteredRepos] = useState<_Repo[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [selectedRepo, setSelectedRepo] = useState<_Repo | null>(null);

    const load = () => {
        setLoading(true);
        agent.getRepos().then(repos => {
            setLoading(false);
            setRepos(repos.map(repo => {
                return {
                    name: repo.readable.split(":")[0],
                    id: repo.withoutBranch,
                    amount: props.permissions.filter(value => value.startsWith("repo."+repo.withoutBranch+".") || value.startsWith("repo.asset."+repo.withoutBranch+".") || value.startsWith("repo.logs."+repo.withoutBranch+".")).length
                }
            }).sort((a, b) => b.amount - a.amount));
        });
    };

    useEffect(() => {
        load();
    }, []);

    return (
        <LoadingContainer open={loading}>
            {!selectedRepo && (<>
                <SearchInput data={repos} setSearchResult={setFilteredRepos} searchableKeys={['name']}></SearchInput>
                {filteredRepos.map(repo => (
                    <Repo key={repo.name} style={{cursor: 'pointer'}} onClick={() => {
                        setSelectedRepo(repo);
                    }}>
                        <h2 style={{display: 'inline-block'}}>{repo.name}</h2>
                        <span style={{float: 'right'}}>{repo.amount} Permissions set</span>
                    </Repo>
                ))}
            </>)}
            {selectedRepo && (
                <div>
                    <Back style={{cursor: 'pointer'}} onClick={() => {
                        load();
                        setSelectedRepo(null);
                    }}>
                        <i className="fa-solid fa-angle-left"></i>
                        <span>Selected Repo: {selectedRepo.name}</span>
                    </Back>

                    <RepoPermissions permissions={props.permissions} onChange={props.onChange} repository={selectedRepo.id}></RepoPermissions>
                </div>
            )}

        </LoadingContainer>
    )



}

